
export default function filterPublications() {
  const form = document.querySelector("#searchform");
  if (form) {
    const publicationsObject = JSON.parse(window.BF_PUBLICATIONS);

    const publicationsDiv = document.querySelector(".Publications");
    const numberOfPublicationsDiv = document.querySelector(
      ".Library-form-pretitle--result"
    );

    const toggleFilter = document.querySelector(".Library-form-filterToggle");
    const toggleTitle = document.querySelector(".Library-form-toggle");
    const filters = document.querySelector(".Library-form-taxonomies");
    const filtersButton = document.querySelector(
      ".Library-form-overlay-button"
    );
    const radioButtons = document.querySelectorAll(".Library-form-radiobutton");
    const mobileClearForm = document.getElementById("clear-form-button");
    const deskClearForm = document.getElementById("clear-form-button-desk");
    const mobileCloseOverlay = document.getElementById("close-overlay-button");
    const showMoreButton = document.getElementById("publications-more-button");

    const searchWord = document.getElementById("search");
    const body = document.querySelector("body");

    let checkedTaxonomies= []
    let sortedTaxonomies = [];
    let currentPage = 1;

    let state = {
      pages: 0,
    };

    const renderData = (publications) => {
      let pubs = "";
      let numberOfPublications = "";
      currentPage = 1;

      const renderString = (terms) => {
        const string = terms.reduce((a, c) => {
          a.push(c.id);
          return a;
        }, []);

        return string.join(", ");
      };

      const publicationString = sortedTaxonomies.publication_type
        ? `av typen "${renderString(sortedTaxonomies.publication_type)}"`
        : "";
      const searchString = searchWord.value ? `för "${searchWord.value}"` : "";
      const subjectString = sortedTaxonomies.subject
        ? `inom "${renderString(sortedTaxonomies.subject)}"`
        : "";
      const sourceString = sortedTaxonomies.source ? 'med källa "Barnafrid"' : "";
      const languageString = sortedTaxonomies.language
        ? `på "${renderString(sortedTaxonomies.language)}"`
        : "";

      let index = 0;
      let numberOfPostsPerPage = 11;
      let page = 0;

      publications.forEach((pub) => {
        index++;
        if (index % numberOfPostsPerPage == 0 || index === 1) {
          page++;
          if (index > 1) pubs += "</div>";
          pubs += `<div class="Publication-page" data-page="${page}">`;
        }

        const publicationClass = pub.password_length > 0
          ? "Publication-container Publication-container--protected"
          : "Publication-container";
        const authorParagraph = `<p class="Publication-meta-author">${pub["publication_meta"].author}</p>`;
        const secureContainer = pub.password_length > 0
          ? `<div class="Publication-password"><span>Lösenordsskyddad</span></div>`
          : "";

        pubs += `<a class="Publication-link" href="${pub["url"]}"><div class="${publicationClass}">
                    ${secureContainer}
                    <div class="Publication-meta-wrapper">
                            <div class="Publication-meta-imageContainer">
                                <img width="78px" height="113px" class="Publication-meta-image" src="${pub["publication_meta"].image}" 
                                srcset="${pub["publication_meta"].imageSrcset || ''}"
                                sizes="(max-width: 78px) 100vw, 78px" alt=""/>
                            </div>
                            <div>
                                <h2 class="Publication-title">${pub["title"]}</h2>
                                ${authorParagraph}
                            </div>
                        </div>
                    </div>
                </a>`;
      });

      publicationsDiv.innerHTML = pubs;
      numberOfPublications += `${publications.length} resultat ${searchString} ${subjectString} ${publicationString} ${sourceString} ${languageString}`;
      numberOfPublicationsDiv.innerHTML = numberOfPublications;

      state.pages = page

      if (state.pages > 1) {
        showMoreButton.style.display = "block";
      } else {
        showMoreButton.style.display = "none";
      }
    };

    renderData(publicationsObject);

    const toggleFilters = () => {
        filters.classList.toggle("Library-form-taxonomies--show");
        toggleTitle.innerHTML =
          toggleTitle.innerHTML === "Visa fler filter"
            ? "Visa färre filter"
            : "Visa fler filter";
        body.classList.toggle("taxonomies-open");
      
    };

    toggleFilter.addEventListener("click", (e) => {
      e.preventDefault();
      toggleFilters();
    });

    filtersButton.addEventListener("click", (e) => {
      e.preventDefault();
      toggleFilters();
    });

    mobileClearForm.addEventListener("click", (e) => {
      e.preventDefault();
      form.reset();
      form.dispatchEvent(new Event("change"));
    });

    deskClearForm.addEventListener("click", (e) => {
      e.preventDefault();
      form.reset();
      form.dispatchEvent(new Event("change"));
    });


    showMoreButton.addEventListener("click", (e) => {
      e.preventDefault();
      currentPage++;

      if (state.pages <= currentPage) {
        showMoreButton.style.display = "none";
      }

      const nextPage = document.querySelector(`[data-page="${currentPage}"]`);
      nextPage.style.display = "block";
    });

    mobileCloseOverlay.addEventListener("click", (e) => {
      e.preventDefault();
      toggleFilters();
    });

    let checked = [];
    Array.from(radioButtons).forEach((radioButton) => {
      radioButton.addEventListener(
        "click",
        (e) => {
          if (checked[radioButton.name] != radioButton) {
            checked[radioButton.name] = radioButton;
          } else {
            radioButton.checked = false;
            checked[radioButton.name] = null;
            form.dispatchEvent(new Event("change"));
          }
        },
        false
      );
    });


    form.addEventListener("submit", (e) => {
      e.preventDefault();
      form.dispatchEvent(new Event("change"));
    });

    
    form.addEventListener("change", (e) => {
      e.preventDefault();


      const filterOnTaxonomies = (searchedPublications) => {
        let publicationsArray = [...searchedPublications];
        checkedTaxonomies = form.querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        );

        if (checkedTaxonomies.length > 0) {
          sortedTaxonomies = [...checkedTaxonomies].reduce((a, c) => {
            // If name ends with [] remove the []
            if (c.name !== "subject" && c.name.slice(-1) === "]") {
              c.name = c.name.substring(0, c.name.length - 2);
            }

            if (a[c.name]) {
              a[c.name] = [...a[c.name], { value: c.value, id: c.id }];
            } else {
              a[c.name] = [{ value: c.value, id: c.id }];
            }
            return a;
          }, {});

          Object.keys(sortedTaxonomies).forEach((tax) => {
            const slugs = sortedTaxonomies[tax].reduce((a, c) => {
              a.push(c.value);
              return a;
            }, []);

            publicationsArray = publicationsArray.filter((pub) => {
              const includes = pub[tax].filter((value) =>
                slugs.includes(value.slug)
              );

              return includes.length;
            });
          });
        } else {
          sortedTaxonomies = [];
        }

        if (searchWord.value.length || checkedTaxonomies.length) {
          deskClearForm.classList.add('Library-form-clearFilter--show')
        } else {
          deskClearForm.classList.remove('Library-form-clearFilter--show')
        }

        renderData(publicationsArray);
      }
  

      if (searchWord && searchWord.value.length > 2) {
        const searchValue = searchWord.value;


        //TODO Rätt endpoint och väck med headers

        fetch(`${barnafrid.base_url}/wp-json/wp/v2/search?search=${searchValue}&per_page=5&page=1&subtype=publication`, { headers: {"Authorization": "Basic YmZwcmV2aWV3OmZpeGFpbm5hbg=="}}).then(response => response.json())
        .then(response => {
            const fetchedFromAPI = [...response]
            filter(fetchedFromAPI)
        });

        const filter = (data) => {
          const apiFilteredPubs = [...publicationsObject.filter(p => data.find(d => d.id === p.id))]
          filterOnTaxonomies(apiFilteredPubs)
        }
       /* searchedPublications = publicationsObject.filter((pub) =>
          pub["title"].toLowerCase().includes(searchValue.toLowerCase())
        );*/
      } else {
        filterOnTaxonomies(publicationsObject)
      }
    
    });
  }
}
